<template>
    <Head title="Tracking"/>
    <div class="flex flex-wrap justify-between content-center items-start w-full">
        <div class="w-full drop-shadow-md"
             :class="{
                'fixed': !user_track,
                'px-2': !user_track,
                'xl:px-12': !user_track,
                '-mt-7': !user_track,
                'z-20': !user_track,
                'justify-center': user_track,
                'flex': user_track,
                'items-center': user_track,
                'p-2': user_track,
                'lg:p-0': user_track
            }">
            <h1
                class="w-full rounded-lg text-4xl sm:text-6xl my-10 lobster text-shadow font-bold bg-slate-900 text-white block"
                :class="{
                'py-2': !user_track,
                'flex': !user_track,
                'items-center': !user_track,
                'px-5': !user_track,
                'flex-wrap': !user_track,
                'justify-between': !user_track,
                'mx-auto': user_track,
                'text-center': user_track,
                'lg:w-1/2': user_track,
                'drop-shadow-md': user_track
            }">
                <span class="drop-shadow">QMulher.pt</span>
                <button v-if="!user_track" @click="submitForm"
                        class="ubuntu py-5 text-sm bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 border border-gray-400 rounded shadow">
                    <i class="fa fa-plus-square"></i> <span>Guardar dados</span>
                </button>
            </h1>
        </div>
        <div class="pt-24 w-full xl:w-2/6 px-2 xl:px-0 xl:pl-12" v-if="!user_track">
            <div class="overflow-hidden shadow-sm rounded-lg">
                <div class="p-6 bg-slate-100 border-b border-gray-200 drop-shadow-md">
                    <div id="app">
                        <div id="loader"
                             class="fixed w-full h-full left-0 top-0 flex justify-center content-center flex-wrap z-10 bg-slate-900/75"
                             :class="{hidden: loaderHidden}">
                            <div class="py-5 bg-white rounded-lg text-center" style="opacity: 0.8;">
                                <img class="inline-block" src="/storage/img/loader.gif"/>
                            </div>
                        </div>
                        <div class="flex justify-between">
                            <h1 class="text-2xl mb-5 lobster drop-shadow text-slate-600">Inserir dados de envio</h1>
                        </div>
                        <div class="flex w-full">
                            <form @submit.prevent="add" class="w-full">
                                <button type="submit" class="hidden" ref="myForm">Submeter</button>
                                <label for="name">Nome de envio</label>
                                <div
                                    class="px-3 py-2 w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                    {{ form.name }}
                                </div>
                                <!--                                <p v-if="errors.name" class="-mt-2 text-red-500 text-xs italic">{{ errors.name }}</p>-->
                                <label for="buyer_name">Nome do titular de pagamento (MBWay/Transf. Bancária)</label>
                                <!--                                <label for="buyer-name-checkbox"-->
                                <!--                                       class="py-2 ml-2">-->
                                <!--                                    <input type="checkbox"-->
                                <!--                                           name="buyer_name_checkbox"-->
                                <!--                                           v-model="buyer_name_checkbox"-->
                                <!--                                           id="buyer-name-checkbox"/>-->
                                <!--                                    Igual ao-->
                                <!--                                    nome de envio</label>-->
                                <!--                                v-if="!buyer_name_checkbox"-->
                                <input autocomplete="off" v-model="form.buyer_name"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="buyer_name" type="text"/>

                                <p v-if="errors.buyer_name" class="-mt-2 text-red-500 text-xs italic">
                                    {{ errors.buyer_name }}</p>
                                <label for="name" class="block">Email</label>
                                <input autocomplete="off" v-model="form.email"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="email" type="email"/>
                                <p v-if="errors.email" class="-mt-2 text-red-500 text-xs italic">{{ errors.email }}</p>
                                <label for="name" class="block">Telefone/Telemóvel</label>
                                <input autocomplete="off" v-model="form.phone"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="phone" type="tel"/>
                                <p v-if="errors.phone" class="-mt-2 text-red-500 text-xs italic">{{ errors.phone }}</p>
                                <label for="address">Morada e código postal</label>
                                <textarea v-model="form.address"
                                          class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                          id="address"/>
                                <p v-if="errors.address" class="-mt-2 text-red-500 text-xs italic">{{
                                        errors.address
                                    }}</p>
                                <label for="country">País</label>
                                <input autocomplete="off" required v-model="form.country"
                                       class="w-full appearance-none my-2 block bg-gray-200 text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       id="country" type="text"/>
                                <p v-if="errors.country" class="-mt-2 text-red-500 text-xs italic">{{
                                        errors.country
                                    }}</p>
                                <input autocomplete="off" v-model="form.rgpd_email" type="checkbox"
                                       class="mr-2 leading-tight" checked/>
                                <label for="country">Aceito receber notícias/campanhas/ofertas relativas à
                                    QMulher</label>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full" :class="{
                'xl:pt-24': !user_track,
                'xl:w-4/6': !user_track,
                'xl:px-12': !user_track,
                'lg:w-1/2': user_track,
                'mx-auto': user_track
            }">
            <div class="flex justify-center items-center w-full p-2 lg:p-0">
                <div class="flex w-full">
                    <div class="w-full">
                        <p class="lobster bg-gray-50 text-slate-600 text-center xl:text-left text-4xl relative rounded-tl-lg rounded-tr-lg p-2 z-0 border-b">
                            <span class="drop-shadow">Encomenda nr. {{ order.id }}</span></p>
                        <table class="w-full overflow-x-auto drop-shadow-md">
                            <thead class="bg-gray-50">
                            <tr>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-center"></th>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-center">Artigo</th>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-center">Tamanho</th>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-center">Cor</th>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-right">Preço Un.</th>
                                <th class="w-24 sm:w-36 py-2 text-xs sm:text-sm text-gray-500 text-right">Valor&nbsp;&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody class="bg-white">
                            <tr v-for="(line,key) of order.order_line"
                                :class="{'border-b': key === (order.order_line.length-1)}">
                                <td>
                                    <a :href="'/storage/img/articles/'+ line.article_id +'/'+line.article.images[0]['filename']"
                                       target="_blank"><img
                                        :src="'/storage/img/articles/'+ line.article_id +'/'+line.article.images[0]['filename']"
                                        class="w-20 ml-2"/></a></td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-center">
                                    {{ line.article.code }}
                                </td>
                                <td class="w-24 sm:w-36 py-4">
                                    <div class="text-xs sm:text-sm text-gray-500 text-center">{{ line.tamanho }}</div>
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-center">{{
                                        line.cor
                                    }}
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">
                                    {{ line.article.price }}
                                    €
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">
                                    {{ Math.round((line.article.price * line.qtd + Number.EPSILON) * 100) / 100 }}
                                    €&nbsp;&nbsp;
                                </td>
                            </tr>
                            <tr class="">
                                <td rowspan="4" colspan="4" class="text-sm text-gray-500">
                                    <div class="flex flex-wrap">
                                        <div class="w-full sm:w-1/2 p-5">
                                            <p class="font-bold lobster text-lg">📦 Portes de envio</p>
                                            <p class="font-bold text-center">
                                                <button @click="shipping_costs" class="my-5 bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow" type="button">
                                                    Preços
                                                </button><br/>
                                                (1 par de calçado equivale a 2 peças)
                                            </p>
                                            <p v-if="order.status.id === 3" class="font-bold text-center py-4" style="font-size:1.1em;">❤ Aguardamos o pagamento ❤<br/>Faça o mais brevemente possível</p>
                                            <p class="font-bold border-b border-t text-center">Agradecemos o envio do
                                                comprovativo por mensagem privada.</p>
                                            <p v-if="!user_track" class="font-bold text-center" style="margin-bottom: 120px;">Após detetado
                                                o pagamento, a sua encomenda segue e no link é disponibilizado
                                                o código de rastreio.</p>
                                            <p v-if="user_track" class="font-bold text-center" style="margin-bottom: 60px;">Após detetado
                                                o pagamento, a sua encomenda segue e no link é disponibilizado
                                                o código de rastreio.</p>
                                        </div>
                                        <div class="w-full sm:w-1/2 p-5">
                                            <p class="text-center border-b"><span class="font-bold lobster text-lg">Métodos de pagamento</span>
                                            </p>
                                            <p class="text-bold mt-2 text-center font-bold">Transferência Bancária</p>
                                            <p class="text-left"><span class="font-bold">Titular:</span> Q MULHER UNIPESSOAL, LDA
                                            </p>
                                            <p><span class="font-bold">IBAN</span><br/>PT50 0007 0000 0078 8215 1142 3</p>
                                            <p><span class="font-bold">NIB</span><br/>0007 0000 0078 8215 1142 3</p>
                                            <p class="text-center mt-2 pt-2 border-t">
                                                <img
                                                    src="https://www.mbway.pt/wp-content/uploads/2020/07/Logo_MBWay@2x.png"
                                                    class="w-16 inline my-2"
                                                    alt="Mbway">
                                            </p>
                                            <p class="text-center">910 439 863</p>
                                            <p class="text-center">
                                                <img
                                                    src="https://www.paypalobjects.com/webstatic/mktg/logo/acceptance_mrk_template_spmbpp.jpg"
                                                    alt="PayPal Acceptance Mark">
                                            </p>
                                            <p class="font-bold text-center" :class="{
                                                '-mt-16': !user_track,
                                                'text-xs': user_track,
                                                '-mt-14': user_track,
                                                'pt-1': user_track
                                            }">
                                                Aceitamos pagamentos PayPal. Por favor solicite através de mensagem
                                                privada.
                                            </p>
                                        </div>
                                    </div>
                                    <p class="text-xs absolute w-full" :class="{
                                        '-mt-4': !user_track,
                                        'text-center': !user_track,
                                        'text-right': user_track,
                                        '-mt-8': user_track,
                                        'pr-2': user_track
                                    }">Reservamo-nos ao direito de
                                        falha de stock perante demora no pagamento. <br v-if="user_track"/>Caso isso aconteça, procederemos à
                                        devolução do montante em causa ou à troca dos respetivos artigos.</p>
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-lg sm:text-xl text-gray-500 text-right">Total a
                                    pagar:
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-lg sm:text-xl text-gray-500 text-right">
                                    {{ order.final_total }}
                                    €&nbsp;&nbsp;
                                </td>
                            </tr>
                            <tr class="">

                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">Custos de
                                    envio:
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">
                                    {{ order.shipping_value ?? 0 }}
                                    €&nbsp;&nbsp;
                                </td>
                            </tr>
                            <tr class="">

                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right"><span
                                    v-if="order.discounts && order.discounts.default">Descontos:</span>
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">
                                    <div v-if="order.discounts && order.discounts.default">
                                        <p v-for="d in order.discounts">{{ d }}&nbsp;&nbsp;</p>
                                    </div>
                                </td>
                            </tr>
                            <tr class="border-b ">

                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 text-right">
                                    <!--                                    Total artigos:-->
                                </td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500 font-bold text-right">
                                    <!--                                    {{-->
                                    <!--                                        Math.round((order.total + Number.EPSILON) * 100) / 100-->
                                    <!--                                    }}-->
                                    <!--                                    €&nbsp;&nbsp;-->
                                </td>
                            </tr>
                            <tr class="">
                                <td></td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500">Estado:</td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500" :class="{'align-middle': user_track}" colspan="3">
                                    <a v-if="!user_track" :class="{'px-4': true, 'py-1': true, 'text-xs': true, 'sm:text-sm': true, 'text-white': true, 'bg-green-400': order.status.id === 5, 'bg-red-400': order.status.id !== 5, 'rounded': true}">
                                        {{ order.status.name }}
                                    </a>
                                    <div v-if="user_track" class="flex flex-wrap items-center">
                                        <div class="w-full sm:w-1/2">
                                            <a class="px-4 py-1 text-xs sm:text-sm text-white rounded"
                                               :class="{ 'bg-green-400':order.status.id === 5, 'bg-red-400': order.status.id !== 5 }">
                                                {{ order.status.name }}
                                            </a>
                                        </div>
                                        <div class="w-full sm:w-1/2 pt-5 sm:pt-0">
                                            <p class="font-bold text-red-600">ATENÇÃO</p>
                                            <p class="font-bold">Morada de envio</p>
                                            {{ order.address }}
                                        </div>
                                    </div>
                                </td>
                                <td colspan="2" class="text-right">
                                    <img alt="logo" class="inline w-1/4" src="/storage/img/logo.jpg">
                                </td>
                            </tr>
                            <tr v-if="parseInt(order.status_id, 10) === 5" class="">
                                <td></td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500">Seguir encomenda:</td>
                                <td class="w-24 sm:w-36 py-4 text-xs sm:text-sm text-gray-500" colspan="6">
                                    <a
                                        class="px-4 py-1 text-white rounded bg-blue-400 hover:bg-blue-300"
                                        target="_blank"
                                        :href="tracking_site + order.tracking_number">{{ order.tracking_number }}</a>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8">&nbsp;</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="text-center" v-if="user_track">
                            <button onclick="location.reload()" type="button"
                                    class="my-5 bg-white hover:bg-gray-100 text-gray-800 font-semibold px-4 py-2 border border-gray-400 rounded shadow">
                                Atualizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

/*table tr:first-child th:first-child {*/
/*    border-top-left-radius: 10px;*/
/*}*/

tr td:last-child, tr th:last-child {
    padding-right: 5px;
}

/*table tr:first-child th:last-child {*/
/*    border-top-right-radius: 10px;*/
/*}*/
</style>
<script>
import {Head, useForm} from '@inertiajs/inertia-vue3';
import Swal from "sweetalert2";
import {ref, watch} from "vue";

export default {
    components: {
        Head
    },
    props: ['order', 'token', 'site_url', 'errors', 'user_track'],
    methods: {
        submitForm() {
            this.$refs.myForm.click()
        }
    },
    setup(props) {

        // const buyer_name_checkbox = ref(props.order.buyer_name === props.order.name);

        const form = useForm({
            name: props.order.name,
            // buyer_name: props.order.buyer_name,
            buyer_name: props.order.buyer_name,
            email: props.order.email,
            phone: props.order.phone,
            shipping_value: props.order.shipping_value,
            address: '',
            postal_one: '',
            postal_two: '',
            locality: '',
            country: 'Portugal',
            rgpd_email: true
        });

        function add() {
            form.put('/orders/' + props.token, options);
        }

        const options = {
            onBefore: function () {
                loaderHidden.value = false;
            },
            onSuccess: function (result) {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    html: 'Dados inseridos com sucesso!'
                }).then(function () {
                    loaderHidden.value = true;
                    location.reload();
                });
                form.reset();
            },
            onError: function () {
                loaderHidden.value = true;
            }
        }
        const loaderHidden = ref(true);

        // watch(
        //     () => buyer_name_checkbox.value,
        //     (s) => {
        //         if (s) {
        //             form.buyer_name = form.name;
        //         } else {
        //             form.buyer_name = '';
        //         }
        //     })

        // watch(
        //     () => form.name,
        //     (s) => {
        //         if (buyer_name_checkbox.value)
        //             form.buyer_name = s;
        //     }
        // )
        let tracking_site = '#';
        const regExpCTT = new RegExp("^[A-z]{2}[0-9]{9}[A-z]{2}$", "gi");

        let isCtt = regExpCTT.exec(props.order.tracking_number);

        const regExpTGE = new RegExp("^[0-9]{12}$", "gi");

        let isTge = regExpTGE.exec(props.order.tracking_number);

        const regExpDPD = new RegExp("^[0-9]{14}[A-z|0-9]$", "gi");

        let isDpd = regExpDPD.exec(props.order.tracking_number);

        if (isCtt && isCtt.length > 0) {
            tracking_site = 'http://ctt.pt/t/';
        } else if (isTge && isTge.length > 0) {
            tracking_site = 'https://www.tge.pt/tracking?tracking=';
        } else if (isDpd && isDpd.length > 0) {
            tracking_site = 'https://tracking.dpd.pt/track-and-trace?reference=';
        }

        const shipping_costs = () => {
            Swal.fire({
                title: 'Tabela Preços Portes 5/2026',
                html: '<table class="mx-auto text-sm">' +
                    '<tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Portugal Continental</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">> 0g - 500g</td><td class="text-right">5,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1 kg/P.Volum.kg</td><td class="text-right">6,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>1 kg - 3 kg/P.Volum.kg</td><td class="text-right">7,50 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Portugal Ilhas</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>0g - 500g</td><td class="text-right">5,50 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 2kg</td><td class="text-right">9,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Internacional ESPANHA (Fora Ilhas)</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>0g - 500g</td><td class="text-right">10,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1kg</td><td class="text-right">14,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>1 kg - 2kg</td><td class="text-right">20,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Internacional (Fora da Europa menos USA)</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>0g - 500g</td><td class="text-right">15,50 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1 kg</td><td class="text-right">25,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>1kg - 2 kg</td><td class="text-right">38,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Internacional (U.S.A)</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>0g - 500g</td><td class="text-right">18,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1 kg</td><td class="text-right">29,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>1 kg - 2 kg</td><td class="text-right">41,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Internacional - (Suíça, Reino Unido,)</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>0 - 500g</td><td class="text-right">12,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1 kg/P.Volum.kg</td><td class="text-right">16,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-200 dark:border-neutral-300">' +
                    '<td class="text-left">>1kg - 2kg/P.Volum.kg</td><td class="text-right">24,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td colspan="2" class="font-bold">Internacional</br>França, Alemanha, Belgica, Holanda, Dinamarca, Lux, Suécia</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>0 - 500g</td><td class="text-right">12,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>500g - 1 kg/P.Volum.kg</td><td class="text-right">15,00 €</td>' +
                    '</tr><tr class="border-b bg-neutral-100 dark:border-neutral-300">' +
                    '<td class="text-left">>1 kg - 3 kg/P.Volum.kg</td><td class="text-right">19,00 €</td>' +
                '</tr></table>'
            }).then(function () {
            });
        }

        return {
            form,
            add,
            options,
            loaderHidden,
            tracking_site,
            shipping_costs
            // buyer_name_checkbox
        }
    }
}
</script>
